import OrganisationFilter, { OrganisationPill } from "DashboardUser/components/Filters/OrganisationFilter";
import BooleanColumnFilter, { BooleanColumnPill } from "DashboardUser/components/Filters/BooleanColumnFilter";
import { FilterPill } from "DashboardUser/components/Filters";
export default function generateFilterLookup({ dashboardFields, surveyQuestions }) {
    let config = {
      organisationId: {
        filter: () => <OrganisationFilter />,
        pill: ({ value, onClear }) => <OrganisationPill value={value} onClear={onClear} />
      },
      searchText: {
        pill: ({ value, onClear }) => <SearchPill value={value} onClear={onClear} />
      }
    }

    // Now add dynamic filters based on dashboard fields
    //valid sources: column custom_field (custom_field_id) goal (goal_id) search (search_id) survey_response (question_id) answerable_question (question_id)
    dashboardFields.forEach(field => {
      if (field.source === 'search') {
        config["field_" + field.id] = {
            filter: () => <BooleanColumnFilter fieldId={field.id} />,
            pill: ({ value, onClear }) => <BooleanColumnPill value={value} onClear={onClear} fieldName={field.name} />
        }
      }
      if (field.source == 'answerable_question' || field.source == 'survey_response') {
        const question = surveyQuestions.find(q => q.id === field.questionId);
        if (question && question.questionType === 'checkbox') {
            config["field_" + field.id] = {
                filter: () => <BooleanColumnFilter fieldId={field.id} />,
                pill: ({ value, onClear }) => <BooleanColumnPill value={value} onClear={onClear} fieldName={field.name} />
            }
        }
      }
    })


    return config
}

function SearchPill({ value, onClear }) {
  if (!value) return null;

  return <FilterPill onClear={onClear}>
    {"Search: " + value}
  </FilterPill>
}